export default ({ app, store }) => {
  // app.nuxt.defaultTransition.beforeEnter = () => {
  //   app.i18n.finalizePendingLocaleChange()
  // }
  app.router.beforeEach(async (to, from, next) => {
    let isClient = process.client
    if (isClient) {
      console.log(store.state)
      //   let currentUrl = location.href
      //   if (currentUrl.indexOf('access_token=') !== -1) {
      //     let wechattoken = currentUrl.split('access_token=')[1]
      //     wechattoken = wechattoken.split('&')[0]
      //     setCookie('token', wechattoken, 5)
      //   }
      let token = store.state.user.token
      if (token) {
        //store.state.user.userinfo.token = token
        try {
          const data = await app.$api.getUserInfo(token)
          store.commit('user/SET_USER', data)
        } catch {}
        app.$api.getUserInfo(token).then((data) => {
          // res = res.data
          // if (res.code == 0) {
          //   res = res.data
          //   res.headImg = res.headImg.replace('http:', 'https:')
          //   store.state.user.userinfo = Object.assign({}, store.state.user.userinfo, res)
          // }
        })
      }
    }
    next()
  })
}
